import * as z from 'zod'

import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const success = () =>
  ({
    schema: z.object({}).passthrough(),
    stepContent: [
      {
        type: 'customComponent',
        name: 'ContentsSuccess',
        inputs: [],
        outputs: [],
        props: {},
      },
    ],
    subFlow: SubFlow.PaymentAndConfirmation,
    hideBackButton: true,
    footer: { hideFooter: true },
  }) as const satisfies AnyStepConfiguration

export default success
